/* @flow strict */

import * as React from 'react';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import Modal from '/client/src/components/Modal';
import ReactSummernote from 'react-summernote';
import DateTimePickerSplitted from '/client/src/components/dateTimePicker/dateTimePickerSplitted';
import available from '/client/src/utils/DOM_available';
import AttendeeBody from './attendeeSection';
import TicketTypeBody from './ticketTypeSection';
import { SummenrNoteToolbar } from '/client/src/constants/';
import { validateInput } from '/client/src/utils/validateInput';
import { emailRegexp } from '/client/src/constants/';
import { convertToLocalTime } from '/client/src/utils/jstz';

import 'bootstrap/js/modal';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/tooltip';
import 'bootstrap/dist/css/bootstrap.css';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleShowSchEmailsPageModal: boolean => void,
  handleSave: ({}) => void,
  singleRow?: {},
  eventId: any
};

class SchEmailsPageModal extends React.Component<PropsType> {
  static contextType = EventDetailContainerContext

  constructor(props: PropsType, context: {}) {
    super(props, context);

    this.singleRow = props.singleRow;
    this.isSetPreset = _.size(this.singleRow);

    this.state = {
      id: this.isSetPreset ? props.singleRow.id : '',
      emailName: this.isSetPreset ? props.singleRow.name : '',
      emailSubject: this.isSetPreset ? props.singleRow.subject : '',
      replyToEmail: this.isSetPreset ? props.singleRow.reply_to : '',
      to: this.isSetPreset ? props.singleRow.recipient_type : 'AllAttendees',
      sendEmailModalSchedule: this.isSetPreset
        ? convertToLocalTime(props.singleRow.schedule_time_utc, context.eventDetail.time_zone_id)
        : null,
      MCEbody: this.isSetPreset ? props.singleRow.body : '',
      isShowPicker: this.isSetPreset
        ? !_.isNull(props.singleRow.schedule_time_utc)
        : false,
      recepients: this.isSetPreset ? props.singleRow.recipients : []
    };
  }

  componentDidMount() {
    this.setState({
      replyToEmail: this.isSetPreset
        ? this.props.singleRow.reply_to
        : this.context.eventDetail.confirmation_email_support_email
    });
  }

  handleSelectRow = (selectedRows: []): any => {
    const recepients = [];

    if (_.size(selectedRows)) _.map(selectedRows, (i: {}): void => this.state.to === 'Attendee' ? recepients.push(i.id) : recepients.push(i.user_id || i.id));

    this.setState({ recepients });
  }

  handleClose = (): any => {
    const { handleShowSchEmailsPageModal } = this.props;

    handleShowSchEmailsPageModal(false);
  }

  validateMessage = (): boolean => {
    const elWrapper = document.getElementById('MCEbody');

    if (!_.size(this.state.MCEbody)) {
      elWrapper.classList.add('has-error');
      elWrapper.querySelector('.note-editable').classList.add('validationElement');

      return false;
    }

    elWrapper.classList.remove('has-error');
    elWrapper
      .querySelector('.note-editable')
      .classList
      .remove('validationElement');

    return true;
  }

  handleSave = () => {
    const {
      emailName,
      emailSubject,
      replyToEmail
    } = this.state;

    const isValidEmailSubjectByRegex = _.size(emailSubject);
    const isValidReplyToEmailByRegex = _.size(replyToEmail) ? emailRegexp.test(replyToEmail) : false;
    const isValidEmailName = _.size(emailName);
    const isValidMCEbody = this.validateMessage();

    if (!isValidEmailSubjectByRegex) {
      validateInput(document.getElementById('emailSubject').parentNode, null);
    }

    if (!isValidReplyToEmailByRegex) {
      validateInput(document.getElementById('replyToEmail').parentNode, null);
    }

    if (!isValidEmailName) {
      validateInput(document.getElementById('emailName').parentNode, null);
    }

    if (isValidEmailSubjectByRegex && isValidReplyToEmailByRegex && isValidEmailName && isValidMCEbody) {
      this.handleClose();
      this.props.handleSave(this.state, !!this.isSetPreset);
    }
  }

  handleChangeInput = (e: SyntheticEvent<HTMLInputElement>) => {
    const name = e.target.id || e.target.name;
    const value = e.target.value;
    const elWrapper = e.currentTarget.parentNode;

    if (name !== 'to') validateInput(elWrapper, value);

    this.setState({
      [name]: value
    });
  }

  handleShowPicker = (status: boolean) => {
    this.setState({
      isShowPicker: status
    });
  }

  handleChangePicker = (date: string) => {
    this.setState({
      sendEmailModalSchedule: date
    });
  }

  handleChangeMCE = (content: string) => {
    this.setState({
      MCEbody: content
    });

    this.validateMessage();
  }


  render(): React.Element {
    const { isOpen, singleRow } = this.props;
    const {
      emailName,
      emailSubject,
      replyToEmail,
      to,
      MCEbody,
      sendEmailModalSchedule,
      isShowPicker,
      recepients
    } = this.state;
    const navigator = available<{ navigator?: HTMLBodyElement }>(
      'navigator',
      null
    );

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
        altView
        isScrollable
      >
        <div
          className="modal-dialog customModal SchEmailsPageModal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{this.isSetPreset ? 'Edit schedule' : 'Add schedule'}</h4>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="companyName">Email Name</label>
                <input
                  type="email"
                  className="form-control"
                  id="emailName"
                  value={emailName}
                  onChange={this.handleChangeInput}
                />
                <span className="validationMessage">This field is required.</span>
              </div>

              <div className="form-group">
                <label htmlFor="supportEmail">Email subject</label>
                <input
                  type="text"
                  className="form-control"
                  id="emailSubject"
                  value={emailSubject}
                  onChange={this.handleChangeInput}
                />
                <span className="validationMessage">This field is required.</span>
              </div>

              <div className="form-group">
                <label htmlFor="supportEmail">Reply to Email</label>
                <input
                  type="text"
                  className="form-control"
                  id="replyToEmail"
                  value={replyToEmail}
                  onChange={this.handleChangeInput}
                />
                <span className="validationMessage">This is not valid email.</span>
              </div>

              <div className="form-group">
                <label>To</label>
                <select
                  className="form-control"
                  name="to"
                  onChange={this.handleChangeInput}
                  value={to}
                >
                  <option value="AllAttendees">All Guests</option>
                  <option value="TicketType">Guests by ticket type</option>
                  <option value="Attendee">Specific guests</option>
                </select>
              </div>

              {to === 'Attendee' && (
                <>
                  <AttendeeBody
                    eventId={this.props.eventId}
                    onHandleSelectRow={this.handleSelectRow}
                    selected={recepients}
                  />
                </>
              )}

              {to === 'TicketType' && (
                <>
                  <TicketTypeBody
                    eventId={this.props.eventId}
                    onHandleSelectRow={this.handleSelectRow}
                    selectedRow={singleRow.recipients}
                  />
                </>
              )}

              <div className="form-group" id="MCEbody">
                <label>Message</label>
                <React.Suspense>
                  {navigator ? (
                    <ReactSummernote
                      children={<div dangerouslySetInnerHTML={{ __html: MCEbody }} />}
                      options={{
                        lang: 'en-US',
                        height: 75,
                        dialogsInBody: true,
                        toolbar: SummenrNoteToolbar
                      }}
                      onChange={this.handleChangeMCE}
                    />
                  ) : null}
                </React.Suspense>
                <span className="validationMessage">This field is required.</span>
              </div>

              <div
                className="form-group"
                style={{
                  display: 'grid',
                  alignItems: 'flex-start',
                  gridTemplateRows: 'repeat(3, 2rem)'
                }}
              >
                <label>Schedule</label>
                <div>
                  <label className="icheckbox" style={{ marginBottom: '15px' }}>
                    <input
                      type="radio"
                      name="sendEmailModalSchedule"
                      value="now"
                      checked={!isShowPicker}
                      onChange={() => {
                        this.handleShowPicker(false);
                      }}
                    />
                    <i className="icheckbox-icon" />
                    <span>Send Now</span>
                  </label>
                </div>

                <div
                  style={{
                    postion: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    zIndex: 9
                  }}
                >
                  <label
                    className="icheckbox"
                    style={{
                      marginBottom: '15px',
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '.5rem'
                    }}
                  >
                    <input
                      type="radio"
                      name="sendEmailModalSchedule"
                      value="custom"
                      checked={isShowPicker}
                      onChange={() => {
                        this.handleShowPicker(true);
                      }}
                    />
                    <i className="icheckbox-icon" />
                    <span>Send On</span>
                  </label>
                  {isShowPicker ? (
                    <div style={{ margin: '0 0 8px 30px' }}>
                    <DateTimePickerSplitted
                      date={sendEmailModalSchedule}
                      time={{
                        showTimeSelect: true,
                        timeFormat: 'HH:mm'
                      }}
                      cb={this.handleChangePicker}
                    />
                  </div>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>
                Close
              </button>
              <button className="btn btn-pink" onClick={this.handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default SchEmailsPageModal;
